import {
  getDailyByAnalyst,
  getPendingMessagesCount,
  getTodaysStats,
  getWeeklyStats,
  getWeeklyStatsByAnalyst,
} from "@/services/approveshield/api/analyst_stats";
import { onlyToday } from "@/utils/date";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useLiveWireStore = create(
  persist(
    (set) => ({
      initialized: false,
      daily: {
        sent_to_qa: 0,
        apps_received: 0,
        kickbacks: 0,
        accuracy: 0,
        sent_to_qa_target: 0,
        pending_community_comms: 0,
        pending_applicant_comms: 0,
      },
      weekly: {
        sent_to_qa: 0,
        apps_received: 0,
        kickbacks: 0,
        accuracy: 0,
        sla: null,
        avg_business_age: 0,
      },
      analystDaily: [],
      analystWeekly: [],
      activeAchievement: null,
      opsDailyTarget: 0,
      opsWeeklyTarget: 0,
      sentToQaDaily: 0,
      sentToQaWeekly: 0,
      showConfetti: false,
      opsDailyTargetAchievedAt: null,

      setInit: (initialized) => set(() => ({ initialized })),

      getDailyAnalystStats: async () => {
        const res = await getDailyByAnalyst();
        if (res?.status === 200 && res?.data) {
          set({ analystDaily: res.data });
        }
        return res;
      },

      getWeeklyAnalystStats: async () => {
        const res = await getWeeklyStatsByAnalyst();
        if (res?.status === 200 && res?.data) {
          set({ analystWeekly: res.data });
        }
        return res;
      },

      getDailyStats: async () => {
        const res = await getTodaysStats();
        if (res?.status === 200 && res?.data) {
          set({ daily: res.data });
        }
        return res;
      },

      getWeeklyStats: async () => {
        const res = await getWeeklyStats();
        if (res?.status === 200 && res?.data) {
          set({ weekly: res.data });
        }
        return res;
      },

      getPendingCommsStats: async () => {
        const res = await getPendingMessagesCount();
        if (res?.status === 200 && res?.data) {
          set({ comms: res.data });
        }
        return res;
      },

      toggleConfetti: (confettiBool) =>
        set((state) => ({ showConfetti: confettiBool })),

      opsDing: () =>
        set((state) => ({
          sentToQaDaily: state.sentToQaDaily + 1,
          sentToQaWeekly: state.sentToQaWeekly + 1,
        })),

      setOpsDailyTargetAchievedAt: (date) =>
        set(() => ({
          opsDailyTargetAchievedAt: date || new Date(),
          activeAchievement: "dailyTarget",
        })),

      setActiveAchievement: (achievement) =>
        set(() => ({ activeAchievement: achievement })),
    }),
    {
      name: "livewire-storage",
      partialize: ({ initialized, ...rest }) => ({ ...rest }),
      merge: (persistedState, currentState) => ({
        ...currentState,
        ...persistedState,
        opsDailyTargetAchievedAt: onlyToday(
          persistedState.opsDailyTargetAchievedAt
        ),
      }),
    }
  )
);
